/**
 * The small "Staff" marker beside a filter only staff are offered, so a
 * reader knows the control is not one the customer ever sees.
 *
 * Contains:
 * - FilterStaffChip (default export)
 */

import React from 'react';
import { useTranslation } from 'react-i18next';

import StatusChip from '@sophocles/components/StatusChip';

const CHIP_SX = { height: 16, fontSize: 10, px: 0.75, ml: 0.75 };

export default function FilterStaffChip() {
  const { t } = useTranslation();
  return <StatusChip color="info" dot={false} label={t('general.staff', 'Staff')} sx={CHIP_SX} />;
}
